export default __webpack_public_path__ + "static/media/change-country-bg-responsive.1f447546.webp";